export const MEDTHOD = {
  GET: "get",
  POST: "post",
  PATCH: "patch",
  DELETE: "delete",
  PUT: "put",
};

export const ROLES = {
  ADMIN: "admin",
  USER: "user",
};

export const LAYOUT = {
  ALOND: "alond",
  CHILD: "child",
};

const project_key = "970cf8ce-4c72-4c78-b69e-630217d484ce"; // AK-HOME

export const STORE_KEY = {
  authen : `${project_key}-authen`,
  current : `${project_key}-current`
}